import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page36',
  templateUrl: './page36.component.html',
  styleUrls: ['./page36.component.css']
})
export class Page36Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
